<template>
  <div class="menu-mobile" id="menu">
    <a href="http://hihonor.com" target="_blank" class="logotype"></a>
    <div class="hamburger" v-on:click="openMenu()">
      <div id="nav-icon3" v-bind:class="{ open: menuOpen }">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="fold" v-bind:class="{ open: menuOpen }">
      <a class="menu-item" v-on:click="goTo('products')">Products</a>
    	<a class="menu-item" v-on:click="goTo('community')">Community</a>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'menuMobile',
  data () {
    return {
      menuOpen: false
    }
  },
  methods: {
    goTo (divId) {
      $('html, body').animate({
        scrollTop: $('#' + divId).offset().top
      }, 'slow')
      if (window.ga) {
        window.ga('send', 'event', 'Menu Mobile', 'click', divId)
      }
      this.menuOpen = false
    },
    openMenu () {
      if (this.menuOpen) {
        this.menuOpen = false
      } else {
        this.menuOpen = true
      }
    }
  },
  mounted () {
    window.onscroll = () => {
      let pos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      let menu = document.getElementById('menu')
      if (pos > (window.innerHeight / 1.5) + 50) {
        menu.setAttribute('class', 'menu-desktop down')
      } else {
        menu.setAttribute('class', 'menu-desktop')
      }
    }
  },
  components: {}
}
</script>

<style scoped>
* {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;    
}
.logotype {
  display: inline-block;
  background-position: center left;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('./../assets/img/logo.svg');
  width: 190px;
  height: 44px;
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: -12px;
  box-sizing: border-box;
}
.menu-mobile {
  position: absolute;
  top: 0px;
  width: 100%;
  z-index: 99999;
}
.hamburger {
  z-index: 99;
  width: 40px;
  height: 45px;
  position: absolute;
  top: 26px;
  right: 20px;
}
.menu-mobile .fold {
  display: none;
  padding-top: 20vh;
  box-sizing: border-box;
}
.menu-mobile .fold.open {
  display: block;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0.9);
}
.fold .menu-item {
  display: block;
  padding: 20px;
  font-size: 50px;
  font-family: 'BigNoodleTitling';
  letter-spacing: 1px;
  text-align: center;
}
* {
  margin: 0;
  padding: 0; 
}

/* Icon 1 */

#nav-icon3 {
  width: 40px;
  height: 45px;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
}

#nav-icon3 span {
  display: block;
  position: absolute;
  height: 4px;
  width: 100%;
  background: #fff;
  border-radius: 0px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}
.open#nav-icon3 span {
  background-color: #666666;
}
/* Icon 3 */

#nav-icon3 span:nth-child(1) {
  top: 0px;
}

#nav-icon3 span:nth-child(2),#nav-icon3 span:nth-child(3) {
  top: 10px;
}

#nav-icon3 span:nth-child(4) {
  top: 20px;
}

#nav-icon3.open span:nth-child(1) {
  top: 18px;
  width: 0%;
  left: 50%;
}

#nav-icon3.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

#nav-icon3.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

#nav-icon3.open span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
}
</style>


// WEBPACK FOOTER //
// MenuMobile.vue?53305dc2